export function formatURL(url: string) {
  return url[url.length - 1] === '/' ? url.substring(0, url.length - 1) : url;
}
